import React from 'react';
import { Routes, Route, Navigate, Link, NavLink } from 'react-router-dom';
import { HubProvider, useApp } from './HubContext';
import Auto from './Auto';
import Rules from './Rules';
import Leaderboard from './Leaderboard';
import Profile from './Profile';
import Account from './Account';
import Live from './Live';
import Watch from './Watch';
import Receipt from './Receipt';
import Admin from './Admin';
import './hub.css';
import './hub2026.css'; // 2026 arcade skin

function Bar() {
  const { user, health } = useApp();
  return (
    <div className="hub-bar">
      <span className="hub-title"><span className="hub-coin" aria-hidden="true" />Betbuilder Hub</span>
      <nav className="hub-tabs" aria-label="Hub">
        {(user ? [['/hub', 'Tips inbox', true], ['/hub/leaderboard', 'Leaderboard'], ['/hub/live', 'Live'], ['/hub/sources', 'Sources'], ['/hub/account', 'Account']]
               : [['/hub/leaderboard', 'Leaderboard'], ['/hub/live', 'Live']]).map(([to, label, end]) =>
          <NavLink key={to} to={to} end={!!end} className={({ isActive }) => 'hub-tab' + (isActive ? ' on' : '')}>{label}</NavLink>)}
      </nav>
      {health?.exchange === 'MOCK' && <span className="hub-pill warn">Paper exchange: no real money yet</span>}
      {user && <Link to="/hub/account" className="hub-pill" title="Change your unit size on Tips Inbox">1u = A${Number(user.unitValue || 10).toFixed(0)}</Link>}
      {user?.killSwitch && <span className="hub-pill danger">Kill switch ON</span>}
    </div>
  );
}

function Private({ children }) {
  const { user, ready } = useApp();
  if (!ready) return <p>Loading…</p>;
  if (!user) return <div className="card"><h2>Log in to use this</h2><p className="fine">The Hub uses your Betbuilder login. <Link to="/">Log in</Link></p></div>;
  return children;
}

function HubRoutes() {
  return (
    <>
      <Bar />
      <Routes>
        <Route index element={<Private><Auto /></Private>} />
        <Route path="sources" element={<Private><Rules /></Private>} />
        <Route path="account" element={<Private><Account /></Private>} />
        <Route path="receipt/:id" element={<Private><Receipt /></Private>} />
        <Route path="admin" element={<Private><Admin /></Private>} />
        <Route path="leaderboard" element={<Leaderboard />} />
        <Route path="leaders/:handle" element={<Profile />} />
        <Route path="live" element={<Live />} />
        <Route path="watch/:handle" element={<Watch />} />
        <Route path="*" element={<Navigate to="/hub" replace />} />
      </Routes>
      <p className="hub-foot">Betbuilder places bets only in your own Betfair account, under your own limits. Past results don’t predict future results. 18+ only. Gamble responsibly. Gambling Help 1800 858 858.</p>
    </>
  );
}

export default function Hub({ signedIn }) {
  return <HubProvider signedIn={signedIn}><div className="hub"><HubRoutes /></div></HubProvider>;
}
